import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedCaracteristiqueTemplateApiService } from './caracteristique-template-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CaracteristiqueTemplateApiService extends GeneratedCaracteristiqueTemplateApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
